var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-primary","expanded":_vm.expanded},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.$t('Reset')))])
}
var staticRenderFns = []

export { render, staticRenderFns }